module.exports = __webpack_public_path__ + "img/pr-3.80726114.png";